import React, { Component } from 'react';
import { actions } from '../../../../helpers/messages';

class SDAFileContent extends Component {
    render() {
        const { content, handleClose, handleDownload, downloading } = this.props;
        
        return <>
            {downloading ? (
                <div className="loading-overlay-upload download-overlay">
                    <span>{actions.download}</span>
                </div>
            ) : null}
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-control content-wrap mb-3">
                        <pre className="sda-content">
                            <code className="user-select-none">{content}</code>
                        </pre>
                    </div>
                </div>
                <hr />
                <div className="col-sm-12 text-end">
                    <button className="btn btn-primary" id="fileDownload" data-testid="downloadBtn" onClick={handleDownload}>Download</button>
                    <button className="btn btn-secondary ms-2" id="closeModal" data-testid="closeModalBtn" onClick={handleClose}>Close</button>
                </div>
            </div>
        </>
    }
}

export default SDAFileContent;
